import { UseMutationOptions } from '@tanstack/react-query';

import { SchedulerWebHookCreateData, SchedulerWebHookId } from '@playq/services-jobot-scheduler';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

export const useWebHookUpdate = (
  options?: UseMutationOptions<
    CommonSuccess,
    GenericFailure | Error,
    { id: SchedulerWebHookId; data: SchedulerWebHookCreateData }
  >
) => {
  return useEitherMutation(({ id, data }) => services2.intergrationsWebHookService.update(id, data), {
    ...options,
  });
};
